import {structuredDataJson} from 'notability-services-common-universal'
import * as React from 'react'
import type {Graph} from 'schema-dts'

// Emits a JSON-LD structured-data block. Rendered as a plain <script> (not through next/head)
// per Next.js guidance — crawlers and LLM fetchers read application/ld+json anywhere in the
// document. The graph builders themselves live in `common-universal`, so services without a React
// runtime can produce the same markup.
export function StructuredData({graph}: {graph: Graph}) {
  return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: structuredDataJson(graph)}} />
}
